import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import materialService from '../services/material.service';
import { setMessage } from './message';
export const fetchMaterialList = createAsyncThunk(
    'material/fetchMaterialList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await materialService.getMaterialList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchMaterialDropdown = createAsyncThunk(
    'material/fetchMaterialDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await materialService.getMaterialDropdown(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchArchivedMaterialList = createAsyncThunk(
    'material/fetchArchivedMaterialList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await materialService.getMaterialArchiveList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
            
        }
    },
);
export const createMaterial = createAsyncThunk(
    'material/createMaterial',
    async (materialData, thunkAPI) => {
        try {
            const response = await materialService.addMaterial(materialData);
            return response.data; // Assuming response contains the created die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const updateMaterial = createAsyncThunk(
    'material/updateMaterial',
    async ({ id, values }, thunkAPI) => {
        try {
            const response = await materialService.updateMaterial(id, values);
            thunkAPI.dispatch(fetchMaterialList({ page: 1, limit: 10 })); // Re-fetch list after update
            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const deleteMaterial = createAsyncThunk(
    'material/deleteMaterial',
    async (id, thunkAPI) => {
        try {
            await materialService.deleteMaterial(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const unArchiveMaterial = createAsyncThunk(
    'material/unArchiveMaterial',
    async (id, thunkAPI) => {
        try {
            await materialService.unArchiveMaterial(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const materialSlice = createSlice({
    name: 'material',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetMaterialList: state => {
            state.list = []; // This will clear the list
        },
        resetCurrentMaterialPage: state => {
            state.currentPage = 1;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchMaterialList.pending, state => {
                state.status = 'pending';
                state.loading = true;
            })
            .addCase(fetchMaterialList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loading = false;
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; 
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchMaterialList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchMaterialDropdown.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchMaterialDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchMaterialDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchArchivedMaterialList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedMaterialList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedMaterialList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.data =  []; 
                state.list =  [];  
                state.error = action.error.message;
            });
        builder
            .addCase(createMaterial.pending, state => {
                state.status = 'loading';
            })
            .addCase(createMaterial.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createMaterial.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateMaterial.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateMaterial.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updatedGroup = action.payload;
                const index = state.data.findIndex(
                    group => group.id === updatedGroup.id,
                ); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updatedGroup; // Replace the old group with the updated one
                }
            })
            .addCase(updateMaterial.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(deleteMaterial.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteMaterial.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteMaterial.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveMaterial.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveMaterial.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveMaterial.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetMaterialList, resetCurrentMaterialPage } = materialSlice.actions;
const { reducer } = materialSlice;
export default reducer;
